/**
 * @description Component-MobileHeader
 */
import './index.less';

import React, { FC, useState } from 'react';
import { Link } from 'react-router-dom';

import { useTheme } from '@/features/global/hooks';
import Logo from '@/layout/Header/Logo';
import Web3Status from '@/layout/Header/Web3Status';

import IpBlocker from '@/components/IpBlocker';
import GetMarginButton from '@/pages/components/GetMarginButton';

import MenuDrawer from './MobileHeaderMenuDrawer/MenuDrawer';
import MenuIcon from './assets/icon-list.svg?react';

interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
}
const MobileHeader: FC<IPropTypes> = function () {
  const { dataTheme } = useTheme();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <>
      {/* <Suspense>{<TopNotice />}</Suspense> */}
      <IpBlocker />
      <div className="syn-mobile-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Link id="logo" className="logo" to="/">
            <Logo dataTheme={dataTheme} />
          </Link>
        </div>
        <div className="syn-mobile-header-right">
          <GetMarginButton />

          {/* <NetworkSwitchDrawer /> */}
          <Web3Status />
          <button className="syn-mobile-header-menu-btn" onClick={() => setIsMenuOpen(true)}>
            <MenuIcon />
          </button>
        </div>
      </div>
      <MenuDrawer open={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </>
  );
};

export default MobileHeader;
